module.exports = __webpack_public_path__ + "roboto-v15-latin-regular.7e367be02cd17a96d513.woff2";


//////////////////
// WEBPACK FOOTER
// /Users/tretapey/Documents/Programmer/craCSS/DOC-in/~/primeng/resources/themes/omega/fonts/roboto-v15-latin-regular.woff2
// module id = ../../../../primeng/resources/themes/omega/fonts/roboto-v15-latin-regular.woff2
// module chunks = 2